import { FC } from 'react';
import { ACTIVE_DAY, ICalendarProps, ICalendarState } from '../../types';
import { localeStore } from 'src/mobx/localesStore';

type TProps = Pick<ICalendarProps, 'maxDetail' | 'selectRange'>;

interface IProps extends TProps, ICalendarState {}

const CalendarDatePeriod: FC<IProps> = (props: IProps): JSX.Element | null => {
  if (props.maxDetail === 'decade' || !props.selectRange) return null;

  return (
    <div className="d-flex flex-row justify-content-between mx-8 mt-2">
      {/* start date */}
      <div className={`d-flex flex-column align-items-center ${props.activeDay === ACTIVE_DAY.START ? 'color-gray2' : 'color-dark'}`}>
        <h2 className="family-medium text-size-12 text-uppercase letter-spacing-12">{localeStore.t('start_date')}</h2>
        <p className="family-semibold text-size-18 mt-1">{props.start_date}</p>
      </div>
      {/* end date */}
      <div className={`d-flex flex-column align-items-center ${props.activeDay === ACTIVE_DAY.END ? 'color-gray2' : 'color-dark'}`}>
        <h2 className="family-medium text-size-12 text-uppercase letter-spacing-12">{localeStore.t('end_date')}</h2>
        <p className="family-semibold text-size-18 mt-1">{props.end_date}</p>
      </div>
    </div>
  );
};

export default CalendarDatePeriod;
